import { isMarketplacePath } from "./marketplaceNavigation";
export const platformLinks = [
  { label: "Home", href: "/", paths: ["/"] },
  { label: "Market Insights", href: "/market", paths: ["/market", "/cards"] },
  {
    label: "My Binders",
    href: "/virtual-binder",
    paths: ["/virtual-binder", "/scan"],
  },
  { label: "Sets", href: "/sets", paths: ["/sets"] },
  {
    label: "AI Tools",
    href: "/ai-tools",
    paths: ["/ai-tools", "/collection-coach", "/ai-grader"],
  },
  {
    label: "Watchlists & Deal Hunter",
    href: "/watchlists",
    paths: ["/watchlists", "/watchlist", "/deal-hunter", "/alerts"],
  },
  {
    label: "Marketplace",
    href: "/marketplace",
    paths: ["/marketplace", "/seller", "/purchases"],
  },
  {
    label: "Llama Lounge",
    href: "/llama-lounge",
    paths: ["/llama-lounge", "/news", "/youtube", "/live-shows"],
  },
];
export function isPlatformLinkActive(href: string, pathname: string) {
  if (href === "/marketplace") return isMarketplacePath(pathname);
  return (
    platformLinks
      .find((link) => link.href === href)
      ?.paths.some(
        (path) =>
          pathname === path ||
          (path !== "/" && pathname.startsWith(path + "/")),
      ) ?? false
  );
}


export const platformGroups = [
  { label: "Collect", description: "Your cards and next chase", links: [platformLinks[2], platformLinks[5]] },
  { label: "Research", description: "Card values, sets and AI guidance", links: [platformLinks[1], platformLinks[3], platformLinks[4]] },
];
